<template>
  <div id="register">
    <Spinner v-if="isLoading"/>
    <form>
      <h1>Εγγραφή νέου χρήστη στο σύστημα</h1>
      <span v-if="errorMsg">{{ errorMsg }}</span>
      
      <input id="name" type="text" v-model.trim="name" required placeholder="Όνομα" autofocus>
      <input id="username" type="text" v-model.trim="username" placeholder="Username" required>
      <input id="email" type="email" v-model.trim="email" placeholder="Email" required>
      <input id="password" type="password" v-model="password" placeholder="Κωδικός" required>
      <input id="password-confirm" type="password" v-model="password_confirmation" placeholder="Επιβεβαίωση Κωδικού" required>
      
      <button type="submit" class="sav-btn sav-btn-red full-width" @click="handleSubmit">
        Εγγραφή
      </button>
      <a href="javascript:void(0)" @click="goBack" class="sav-btn sav-btn-link full-width align-center">Επιστροφή</a>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  props : ["nextUrl"],
  components: {
    Spinner
  },
  data(){
    return {
      isLoading: false,
      apiUrl: this.$parent.apiUrl,
      name : "",
      username : "",
      email : "",
      password : "",
      password_confirmation : "",
      errorMsg: ""
    }
  },
  methods : {
    handleSubmit(e) {
      e.preventDefault()

      if (this.name == "" || this.email == "" || this.username == "" || this.password.length == 0 || this.password_confirmation.length == 0) {
        this.errorMsg = "Συμπληρώστε όλα τα πεδία"
      } else {
        if (this.password != this.password_confirmation) {
          this.errorMsg = "Δεν ταιριάζουν οι κωδικοί"
        } else {
          this.errorMsg = "";
          this.register();
        }
      }
    },
    register() {
      this.isLoading = true;
      let url = this.apiUrl + "/register"
        axios.post(url, {
          name: this.name,
          username: this.username,
          email: this.email,
          password: this.password
        })
        .then(response => {
          if (response.status == 200) {
            this.errorMsg = "";
            this.$router.push("/users");
          }  else {
            this.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          } 
          this.isLoading = false;
        })
        .catch(error => {
          let response = error.response;
          if (!response) {
            this.errorMsg = "Μη ενεργός server";
          } else {
            this.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
          this.isLoading = false;
        });
    },
    goBack: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss">
@import "./../scss/_colors";

html, body, #app, #register {
  height: 100%;
}

#register {
  background-image: linear-gradient($blue, $blue 40%, white 40%, white);
  display: flex;
  justify-content: center;
  padding-top: 50px;
  align-items: flex-start;

  form {
    width: 500px;
    padding: 50px;
    background-color: white;
    box-shadow: 0 2px 9px rgba(0,0,0,.25);
    display: flex;
    flex-direction: column;

    h1 {
      margin-top: 0;
      margin-bottom: 40px;
      font-weight: normal;
    }

    span {
      margin-bottom: 20px;
      color: $red;
      font-weight: bold;
    }

    input {
      border: none;
      border-bottom: 2px solid $blue;
      margin-bottom: 30px;
      padding: 0;
      box-shadow: none;

      &::placeholder {
        color: $blue;
      }
    }

    button {
      margin-bottom: 20px;
    }
  }
}
</style>
